import { makeStyles } from "tss-react/mui";
import { Step, StepLabel, Stepper } from "@mui/material";

/**
 * A custom stepper component for rendering step-by-step navigation.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {function} props.setActiveStep
 * @param {object[]} props.steps
 * @param {boolean} props.disabled
 * @returns {JSX.Element}
 */

export function MiStepper({
  activeStep = 0,
  steps = [],
  setActiveStep = () => null,
  disabled = false,
}) {
  const { classes } = useStyles();

  const handleStep = (step) => () => {
    if (!disabled) {
      setActiveStep(step);
    }
  };

  return (
    <Stepper
      activeStep={activeStep}
      className={classes.stepperContainer}
      alternativeLabel
    >
      {steps.map((step) => (
        <Step key={step.label}>
          <StepLabel
            className={classes.stepLabel}
            onClick={handleStep(step.value)}
          >
            {step.label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

const useStyles = makeStyles()((theme) => ({
  stepperContainer: {
    backgroundColor: theme.palette.common.white,
    padding: 4,
    width: "100%",
  },
  stepLabel: {
    cursor: "pointer",
    "& .MuiStepLabel-alternativeLabel": {
      marginTop: 0,
    },
  },
}));
